import {
  getOnboardingData,
  singleConnectedSoftware
} from "../../redux/loginSlice";
import { getProfile } from "../../redux/userManagementSlice";
import {
  COMPLETE_ACCOUNT_SETUP,
  LASTCONNECTEDSOFTWARE,
  PARTNER_DASHBOARD
} from "../../route/paths";
import { COMPLETED, DISCONNECTED } from "../../utils/constants/appConstants";

const PARTNER_ROLE_NAME = "ReferralPartner";

export default function useGetOnboardingData({
  dispatch,
  navigate,
  checkSoftwareConnected
}) {
  const handleGetOnboardingData = async (successMessage) => {
    const [onboardingResult, profileResult, lastConnectedSoftData] =
      await Promise.allSettled([
        dispatch(getOnboardingData()).unwrap(),
        dispatch(getProfile()).unwrap(),
        dispatch(singleConnectedSoftware()).unwrap()
      ]);

    const response =
      onboardingResult.status === "fulfilled" ? onboardingResult.value : null;
    const apiResponse =
      profileResult.status === "fulfilled" ? profileResult.value : null;
    const singleConnectedData =
      lastConnectedSoftData.status === "fulfilled"
        ? lastConnectedSoftData.value?.data?.data?.connectionStatus
        : null;

    const onboardingDetails = response?.data?.data ?? {};
    const onboardingStatus = onboardingDetails?.onboardingStatus;
    const onboardingIsConcent = onboardingDetails?.isCreditConsentAccepted;

    const profileData = apiResponse?.data?.data;
    const forceApplicationStatus =
      profileData?.systemSettings?.forceApplicationProcess;

    const isPartner =
      Array.isArray(profileData?.roles) &&
      profileData.roles.some((r) => r.name === PARTNER_ROLE_NAME);

    if (isPartner) {
      navigate(PARTNER_DASHBOARD, { state: { successMessage } });
      return;
    }

    if (
      onboardingStatus === COMPLETED &&
      onboardingIsConcent === true &&
      forceApplicationStatus
    ) {
      navigate(COMPLETE_ACCOUNT_SETUP, {
        state: { successMessage }
      });
      return;
    }

    if (singleConnectedData === DISCONNECTED) {
      navigate(LASTCONNECTEDSOFTWARE, {
        state: { successMessage }
      });
      return;
    }

    if (onboardingStatus !== COMPLETED && onboardingIsConcent === true) {
      navigate(COMPLETE_ACCOUNT_SETUP, {
        state: { successMessage }
      });
      return;
    }

    checkSoftwareConnected(successMessage);
  };

  return handleGetOnboardingData;
}
